import queryString from 'query-string';
import React from 'react';

import { config } from '../config';

function getQrCodeSrc(options: { appid: string; agentid: string; redirect_uri: string; state: string; href?: string }) {
  const query = queryString.stringify(options);
  return `https://open.work.weixin.qq.com/wwopen/sso/qrConnect?${query}`;
}

/**
 * 企业微信登录二维码
 * @see http://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js
 */
export const WechatWorkLogin = (props: { redirectPath: string; returnPath: string }) => {
  const redirectUri = `${config.BASE_URL}/#${props.redirectPath}?returnPath=${props.returnPath}`;

  const qrCodeSrc = getQrCodeSrc({
    appid: config.WECHAT_WORK_APP_ID,
    agentid: config.WECHAT_WORK_AGENT_ID,
    redirect_uri: redirectUri,
    state: '',
  });

  return (
    <iframe
      src={qrCodeSrc}
      frameBorder={0}
      scrolling="no"
      width={300}
      height={400}
      onLoad={e => {
        window.addEventListener('message', document => {
          if (document.data && document.origin.indexOf('work.weixin.qq.com') > -1) {
            window.location.href = document.data;
          }
        });
        const contentWindow = e.currentTarget.contentWindow;
        if (contentWindow) {
          contentWindow.postMessage('ask_usePostMessage', '*');
        }
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/WechatWorkLogin.tsx